/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CanadaSettings,
  CanadaSettingsRequest,
  ClientAccess,
  ClientAccessRequest,
  DeadlineAlert,
  Dossier,
  DossierItem,
  DossierItemRequest,
  DossierMessage,
  DossierRequest,
  DossierSummary,
  ExtractRequest,
  GeneratedDocument,
  ImmigrationDossiersChecksRetrieve200,
  ImmigrationDossiersDrawsRetrieve200,
  ImmigrationDossiersEstimateRetrieve200,
  ImmigrationDossiersExtractCreate200,
  ImmigrationDossiersFormsRetrieve200,
  ImmigrationDossiersFswRetrieve200,
  ImmigrationDossiersLeversRetrieve200,
  ImmigrationDossiersListParams,
  ImmigrationDossiersOfficerReviewCreate200,
  ImmigrationDossiersOfficerReviewRetrieve200,
  ImmigrationDossiersProvincesRetrieve200,
  ImmigrationDossiersStrategyCreate200,
  ImmigrationDossiersStrategyRetrieve200,
  ImmigrationDrawsListParams,
  ImmigrationInterestsListParams,
  ImmigrationItemsListParams,
  ImmigrationRulesListParams,
  ImmigrationSettingsListParams,
  MessageInRequest,
  OfficerReview,
  PaginatedCanadaSettingsList,
  PaginatedDossierItemList,
  PaginatedDossierList,
  PaginatedDrawList,
  PaginatedProvincialInterestList,
  PaginatedRuleTableList,
  PassportValuesRequest,
  PatchedCanadaSettingsRequest,
  PatchedDossierItemRequest,
  PatchedDossierRequest,
  PatchedProvincialInterestRequest,
  ProvincialInterest,
  ProvincialInterestRequest,
  Strategy,
  StrategyRequestRequest,
  SubmittedRequest,
  UploadRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * P4-01: open deadline alerts (an advisor sees those of their own files).
 */
export type immigrationAlertsListResponse200 = {
  data: DeadlineAlert[]
  status: 200
}
    
export type immigrationAlertsListResponseSuccess = (immigrationAlertsListResponse200) & {
  headers: Headers;
};
;

export type immigrationAlertsListResponse = (immigrationAlertsListResponseSuccess)

export const getImmigrationAlertsListUrl = () => {


  

  return `/api/v1/immigration/alerts/`
}

export const immigrationAlertsList = async ( options?: RequestInit): Promise<immigrationAlertsListResponse> => {
  
  return apiFetch<immigrationAlertsListResponse>(getImmigrationAlertsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationAlertsListQueryKey = () => {
    return [
    `/api/v1/immigration/alerts/`
    ] as const;
    }

    
export const getImmigrationAlertsListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationAlertsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationAlertsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationAlertsList>>> = ({ signal }) => immigrationAlertsList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationAlertsListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationAlertsList>>>
export type ImmigrationAlertsListQueryError = unknown


export function useImmigrationAlertsList<TData = Awaited<ReturnType<typeof immigrationAlertsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationAlertsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationAlertsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationAlertsList<TData = Awaited<ReturnType<typeof immigrationAlertsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationAlertsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationAlertsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationAlertsList<TData = Awaited<ReturnType<typeof immigrationAlertsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationAlertsList<TData = Awaited<ReturnType<typeof immigrationAlertsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationAlertsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P4-01: open deadline alerts (an advisor sees those of their own files).
 */
export type immigrationAlertsRetrieveResponse200 = {
  data: DeadlineAlert
  status: 200
}
    
export type immigrationAlertsRetrieveResponseSuccess = (immigrationAlertsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationAlertsRetrieveResponse = (immigrationAlertsRetrieveResponseSuccess)

export const getImmigrationAlertsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/alerts/${id}/`
}

export const immigrationAlertsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationAlertsRetrieveResponse> => {
  
  return apiFetch<immigrationAlertsRetrieveResponse>(getImmigrationAlertsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationAlertsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/alerts/${id}/`
    ] as const;
    }

    
export const getImmigrationAlertsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationAlertsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>> = ({ signal }) => immigrationAlertsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationAlertsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>>
export type ImmigrationAlertsRetrieveQueryError = unknown


export function useImmigrationAlertsRetrieve<TData = Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationAlertsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationAlertsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationAlertsRetrieve<TData = Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationAlertsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationAlertsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationAlertsRetrieve<TData = Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationAlertsRetrieve<TData = Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationAlertsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P4-01: open deadline alerts (an advisor sees those of their own files).
 */
export type immigrationAlertsHandleCreateResponse200 = {
  data: DeadlineAlert
  status: 200
}
    
export type immigrationAlertsHandleCreateResponseSuccess = (immigrationAlertsHandleCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationAlertsHandleCreateResponse = (immigrationAlertsHandleCreateResponseSuccess)

export const getImmigrationAlertsHandleCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/alerts/${id}/handle/`
}

export const immigrationAlertsHandleCreate = async (id: string, options?: RequestInit): Promise<immigrationAlertsHandleCreateResponse> => {
  
  return apiFetch<immigrationAlertsHandleCreateResponse>(getImmigrationAlertsHandleCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationAlertsHandleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationAlertsHandleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationAlertsHandleCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationAlertsHandleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>>
    
    export type ImmigrationAlertsHandleCreateMutationError = unknown

    export const useImmigrationAlertsHandleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationAlertsHandleCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationAlertsHandleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersListResponse200 = {
  data: PaginatedDossierList
  status: 200
}
    
export type immigrationDossiersListResponseSuccess = (immigrationDossiersListResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersListResponse = (immigrationDossiersListResponseSuccess)

export const getImmigrationDossiersListUrl = (params?: ImmigrationDossiersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/dossiers/?${stringifiedParams}` : `/api/v1/immigration/dossiers/`
}

export const immigrationDossiersList = async (params?: ImmigrationDossiersListParams, options?: RequestInit): Promise<immigrationDossiersListResponse> => {
  
  return apiFetch<immigrationDossiersListResponse>(getImmigrationDossiersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersListQueryKey = (params?: ImmigrationDossiersListParams,) => {
    return [
    `/api/v1/immigration/dossiers/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationDossiersListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersList>>, TError = unknown>(params?: ImmigrationDossiersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersList>>> = ({ signal }) => immigrationDossiersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersList>>>
export type ImmigrationDossiersListQueryError = unknown


export function useImmigrationDossiersList<TData = Awaited<ReturnType<typeof immigrationDossiersList>>, TError = unknown>(
 params: undefined |  ImmigrationDossiersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersList<TData = Awaited<ReturnType<typeof immigrationDossiersList>>, TError = unknown>(
 params?: ImmigrationDossiersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersList<TData = Awaited<ReturnType<typeof immigrationDossiersList>>, TError = unknown>(
 params?: ImmigrationDossiersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersList<TData = Awaited<ReturnType<typeof immigrationDossiersList>>, TError = unknown>(
 params?: ImmigrationDossiersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationDossiersCreateResponse201 = {
  data: Dossier
  status: 201
}
    
export type immigrationDossiersCreateResponseSuccess = (immigrationDossiersCreateResponse201) & {
  headers: Headers;
};
;

export type immigrationDossiersCreateResponse = (immigrationDossiersCreateResponseSuccess)

export const getImmigrationDossiersCreateUrl = () => {


  

  return `/api/v1/immigration/dossiers/`
}

export const immigrationDossiersCreate = async (dossierRequest: DossierRequest, options?: RequestInit): Promise<immigrationDossiersCreateResponse> => {
  
  return apiFetch<immigrationDossiersCreateResponse>(getImmigrationDossiersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dossierRequest,)
  }
);}




export const getImmigrationDossiersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersCreate>>, TError,{data: DossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersCreate>>, TError,{data: DossierRequest}, TContext> => {

const mutationKey = ['immigrationDossiersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersCreate>>, {data: DossierRequest}> = (props) => {
          const {data} = props ?? {};

          return  immigrationDossiersCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersCreate>>>
    export type ImmigrationDossiersCreateMutationBody = DossierRequest
    export type ImmigrationDossiersCreateMutationError = unknown

    export const useImmigrationDossiersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersCreate>>, TError,{data: DossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersCreate>>,
        TError,
        {data: DossierRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersRetrieveResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersRetrieveResponseSuccess = (immigrationDossiersRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersRetrieveResponse = (immigrationDossiersRetrieveResponseSuccess)

export const getImmigrationDossiersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/`
}

export const immigrationDossiersRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersRetrieveResponse>(getImmigrationDossiersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/`
    ] as const;
    }

    
export const getImmigrationDossiersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>> = ({ signal }) => immigrationDossiersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>>
export type ImmigrationDossiersRetrieveQueryError = unknown


export function useImmigrationDossiersRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationDossiersUpdateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersUpdateResponseSuccess = (immigrationDossiersUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersUpdateResponse = (immigrationDossiersUpdateResponseSuccess)

export const getImmigrationDossiersUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/`
}

export const immigrationDossiersUpdate = async (id: string,
    dossierRequest: DossierRequest, options?: RequestInit): Promise<immigrationDossiersUpdateResponse> => {
  
  return apiFetch<immigrationDossiersUpdateResponse>(getImmigrationDossiersUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dossierRequest,)
  }
);}




export const getImmigrationDossiersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersUpdate>>, TError,{id: string;data: DossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersUpdate>>, TError,{id: string;data: DossierRequest}, TContext> => {

const mutationKey = ['immigrationDossiersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersUpdate>>, {id: string;data: DossierRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersUpdate>>>
    export type ImmigrationDossiersUpdateMutationBody = DossierRequest
    export type ImmigrationDossiersUpdateMutationError = unknown

    export const useImmigrationDossiersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersUpdate>>, TError,{id: string;data: DossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersUpdate>>,
        TError,
        {id: string;data: DossierRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersPartialUpdateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersPartialUpdateResponseSuccess = (immigrationDossiersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersPartialUpdateResponse = (immigrationDossiersPartialUpdateResponseSuccess)

export const getImmigrationDossiersPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/`
}

export const immigrationDossiersPartialUpdate = async (id: string,
    patchedDossierRequest: PatchedDossierRequest, options?: RequestInit): Promise<immigrationDossiersPartialUpdateResponse> => {
  
  return apiFetch<immigrationDossiersPartialUpdateResponse>(getImmigrationDossiersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedDossierRequest,)
  }
);}




export const getImmigrationDossiersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>, TError,{id: string;data: PatchedDossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>, TError,{id: string;data: PatchedDossierRequest}, TContext> => {

const mutationKey = ['immigrationDossiersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>, {id: string;data: PatchedDossierRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>>
    export type ImmigrationDossiersPartialUpdateMutationBody = PatchedDossierRequest
    export type ImmigrationDossiersPartialUpdateMutationError = unknown

    export const useImmigrationDossiersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>, TError,{id: string;data: PatchedDossierRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersPartialUpdate>>,
        TError,
        {id: string;data: PatchedDossierRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The client accepted the notice (assistance, not advice — D-068), recorded and dated.
 */
export type immigrationDossiersAcceptNoticeCreateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersAcceptNoticeCreateResponseSuccess = (immigrationDossiersAcceptNoticeCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersAcceptNoticeCreateResponse = (immigrationDossiersAcceptNoticeCreateResponseSuccess)

export const getImmigrationDossiersAcceptNoticeCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/accept_notice/`
}

export const immigrationDossiersAcceptNoticeCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersAcceptNoticeCreateResponse> => {
  
  return apiFetch<immigrationDossiersAcceptNoticeCreateResponse>(getImmigrationDossiersAcceptNoticeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersAcceptNoticeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersAcceptNoticeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersAcceptNoticeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersAcceptNoticeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>>
    
    export type ImmigrationDossiersAcceptNoticeCreateMutationError = unknown

    export const useImmigrationDossiersAcceptNoticeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersAcceptNoticeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersAcceptNoticeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Law 2024/017: the client agreed (POST) or no longer agrees (DELETE) that the agency's AI
reads the pieces of their file. Recorded with who entered it and when.
 */
export type immigrationDossiersAiConsentCreateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersAiConsentCreateResponseSuccess = (immigrationDossiersAiConsentCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersAiConsentCreateResponse = (immigrationDossiersAiConsentCreateResponseSuccess)

export const getImmigrationDossiersAiConsentCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/ai-consent/`
}

export const immigrationDossiersAiConsentCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersAiConsentCreateResponse> => {
  
  return apiFetch<immigrationDossiersAiConsentCreateResponse>(getImmigrationDossiersAiConsentCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersAiConsentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersAiConsentCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersAiConsentCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersAiConsentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>>
    
    export type ImmigrationDossiersAiConsentCreateMutationError = unknown

    export const useImmigrationDossiersAiConsentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersAiConsentCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersAiConsentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Law 2024/017: the client agreed (POST) or no longer agrees (DELETE) that the agency's AI
reads the pieces of their file. Recorded with who entered it and when.
 */
export type immigrationDossiersAiConsentDestroyResponse204 = {
  data: void
  status: 204
}
    
export type immigrationDossiersAiConsentDestroyResponseSuccess = (immigrationDossiersAiConsentDestroyResponse204) & {
  headers: Headers;
};
;

export type immigrationDossiersAiConsentDestroyResponse = (immigrationDossiersAiConsentDestroyResponseSuccess)

export const getImmigrationDossiersAiConsentDestroyUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/ai-consent/`
}

export const immigrationDossiersAiConsentDestroy = async (id: string, options?: RequestInit): Promise<immigrationDossiersAiConsentDestroyResponse> => {
  
  return apiFetch<immigrationDossiersAiConsentDestroyResponse>(getImmigrationDossiersAiConsentDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getImmigrationDossiersAiConsentDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersAiConsentDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersAiConsentDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersAiConsentDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>>
    
    export type ImmigrationDossiersAiConsentDestroyMutationError = unknown

    export const useImmigrationDossiersAiConsentDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersAiConsentDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersAiConsentDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * GET: the lines; POST: (re)generate the missing lines for the current profile.
 */
export type immigrationDossiersChecklistListResponse200 = {
  data: DossierItem[]
  status: 200
}
    
export type immigrationDossiersChecklistListResponseSuccess = (immigrationDossiersChecklistListResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersChecklistListResponse = (immigrationDossiersChecklistListResponseSuccess)

export const getImmigrationDossiersChecklistListUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/checklist/`
}

export const immigrationDossiersChecklistList = async (id: string, options?: RequestInit): Promise<immigrationDossiersChecklistListResponse> => {
  
  return apiFetch<immigrationDossiersChecklistListResponse>(getImmigrationDossiersChecklistListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersChecklistListQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/checklist/`
    ] as const;
    }

    
export const getImmigrationDossiersChecklistListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersChecklistListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>> = ({ signal }) => immigrationDossiersChecklistList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersChecklistListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>>
export type ImmigrationDossiersChecklistListQueryError = unknown


export function useImmigrationDossiersChecklistList<TData = Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersChecklistList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersChecklistList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersChecklistList<TData = Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersChecklistList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersChecklistList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersChecklistList<TData = Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersChecklistList<TData = Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersChecklistListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * GET: the lines; POST: (re)generate the missing lines for the current profile.
 */
export type immigrationDossiersChecklistCreateResponse200 = {
  data: DossierItem[]
  status: 200
}
    
export type immigrationDossiersChecklistCreateResponseSuccess = (immigrationDossiersChecklistCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersChecklistCreateResponse = (immigrationDossiersChecklistCreateResponseSuccess)

export const getImmigrationDossiersChecklistCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/checklist/`
}

export const immigrationDossiersChecklistCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersChecklistCreateResponse> => {
  
  return apiFetch<immigrationDossiersChecklistCreateResponse>(getImmigrationDossiersChecklistCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersChecklistCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersChecklistCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersChecklistCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersChecklistCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>>
    
    export type ImmigrationDossiersChecklistCreateMutationError = unknown

    export const useImmigrationDossiersChecklistCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersChecklistCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersChecklistCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersChecksRetrieveResponse200 = {
  data: ImmigrationDossiersChecksRetrieve200
  status: 200
}
    
export type immigrationDossiersChecksRetrieveResponseSuccess = (immigrationDossiersChecksRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersChecksRetrieveResponse = (immigrationDossiersChecksRetrieveResponseSuccess)

export const getImmigrationDossiersChecksRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/checks/`
}

export const immigrationDossiersChecksRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersChecksRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersChecksRetrieveResponse>(getImmigrationDossiersChecksRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersChecksRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/checks/`
    ] as const;
    }

    
export const getImmigrationDossiersChecksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersChecksRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>> = ({ signal }) => immigrationDossiersChecksRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersChecksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>>
export type ImmigrationDossiersChecksRetrieveQueryError = unknown


export function useImmigrationDossiersChecksRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersChecksRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersChecksRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersChecksRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersChecksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersChecksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Messages with the client about this file; opening them marks the client's as read.
 */
export type immigrationDossiersClientMessagesListResponse200 = {
  data: DossierMessage[]
  status: 200
}
    
export type immigrationDossiersClientMessagesListResponseSuccess = (immigrationDossiersClientMessagesListResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersClientMessagesListResponse = (immigrationDossiersClientMessagesListResponseSuccess)

export const getImmigrationDossiersClientMessagesListUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/client-messages/`
}

export const immigrationDossiersClientMessagesList = async (id: string, options?: RequestInit): Promise<immigrationDossiersClientMessagesListResponse> => {
  
  return apiFetch<immigrationDossiersClientMessagesListResponse>(getImmigrationDossiersClientMessagesListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersClientMessagesListQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/client-messages/`
    ] as const;
    }

    
export const getImmigrationDossiersClientMessagesListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersClientMessagesListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>> = ({ signal }) => immigrationDossiersClientMessagesList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersClientMessagesListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>>
export type ImmigrationDossiersClientMessagesListQueryError = unknown


export function useImmigrationDossiersClientMessagesList<TData = Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersClientMessagesList<TData = Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersClientMessagesList<TData = Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersClientMessagesList<TData = Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersClientMessagesListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Messages with the client about this file; opening them marks the client's as read.
 */
export type immigrationDossiersClientMessagesCreateResponse200 = {
  data: DossierMessage[]
  status: 200
}
    
export type immigrationDossiersClientMessagesCreateResponseSuccess = (immigrationDossiersClientMessagesCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersClientMessagesCreateResponse = (immigrationDossiersClientMessagesCreateResponseSuccess)

export const getImmigrationDossiersClientMessagesCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/client-messages/`
}

export const immigrationDossiersClientMessagesCreate = async (id: string,
    messageInRequest: MessageInRequest, options?: RequestInit): Promise<immigrationDossiersClientMessagesCreateResponse> => {
  
  return apiFetch<immigrationDossiersClientMessagesCreateResponse>(getImmigrationDossiersClientMessagesCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      messageInRequest,)
  }
);}




export const getImmigrationDossiersClientMessagesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>, TError,{id: string;data: MessageInRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>, TError,{id: string;data: MessageInRequest}, TContext> => {

const mutationKey = ['immigrationDossiersClientMessagesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>, {id: string;data: MessageInRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersClientMessagesCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersClientMessagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>>
    export type ImmigrationDossiersClientMessagesCreateMutationBody = MessageInRequest
    export type ImmigrationDossiersClientMessagesCreateMutationError = unknown

    export const useImmigrationDossiersClientMessagesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>, TError,{id: string;data: MessageInRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersClientMessagesCreate>>,
        TError,
        {id: string;data: MessageInRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersClientMessagesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-077: the owner or the manager opens (or closes) the client's follow-up in the app.
 */
export type immigrationDossiersClientAccessRetrieveResponse200 = {
  data: ClientAccess
  status: 200
}
    
export type immigrationDossiersClientAccessRetrieveResponseSuccess = (immigrationDossiersClientAccessRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersClientAccessRetrieveResponse = (immigrationDossiersClientAccessRetrieveResponseSuccess)

export const getImmigrationDossiersClientAccessRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/client_access/`
}

export const immigrationDossiersClientAccessRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersClientAccessRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersClientAccessRetrieveResponse>(getImmigrationDossiersClientAccessRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersClientAccessRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/client_access/`
    ] as const;
    }

    
export const getImmigrationDossiersClientAccessRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersClientAccessRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>> = ({ signal }) => immigrationDossiersClientAccessRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersClientAccessRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>>
export type ImmigrationDossiersClientAccessRetrieveQueryError = unknown


export function useImmigrationDossiersClientAccessRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersClientAccessRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersClientAccessRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersClientAccessRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersClientAccessRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-077: the owner or the manager opens (or closes) the client's follow-up in the app.
 */
export type immigrationDossiersClientAccessCreateResponse200 = {
  data: ClientAccess
  status: 200
}
    
export type immigrationDossiersClientAccessCreateResponseSuccess = (immigrationDossiersClientAccessCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersClientAccessCreateResponse = (immigrationDossiersClientAccessCreateResponseSuccess)

export const getImmigrationDossiersClientAccessCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/client_access/`
}

export const immigrationDossiersClientAccessCreate = async (id: string,
    clientAccessRequest: ClientAccessRequest, options?: RequestInit): Promise<immigrationDossiersClientAccessCreateResponse> => {
  
  return apiFetch<immigrationDossiersClientAccessCreateResponse>(getImmigrationDossiersClientAccessCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      clientAccessRequest,)
  }
);}




export const getImmigrationDossiersClientAccessCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>, TError,{id: string;data: ClientAccessRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>, TError,{id: string;data: ClientAccessRequest}, TContext> => {

const mutationKey = ['immigrationDossiersClientAccessCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>, {id: string;data: ClientAccessRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersClientAccessCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersClientAccessCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>>
    export type ImmigrationDossiersClientAccessCreateMutationBody = ClientAccessRequest
    export type ImmigrationDossiersClientAccessCreateMutationError = unknown

    export const useImmigrationDossiersClientAccessCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>, TError,{id: string;data: ClientAccessRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersClientAccessCreate>>,
        TError,
        {id: string;data: ClientAccessRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersClientAccessCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-077: the owner or the manager opens (or closes) the client's follow-up in the app.
 */
export type immigrationDossiersClientAccessDestroyResponse204 = {
  data: void
  status: 204
}
    
export type immigrationDossiersClientAccessDestroyResponseSuccess = (immigrationDossiersClientAccessDestroyResponse204) & {
  headers: Headers;
};
;

export type immigrationDossiersClientAccessDestroyResponse = (immigrationDossiersClientAccessDestroyResponseSuccess)

export const getImmigrationDossiersClientAccessDestroyUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/client_access/`
}

export const immigrationDossiersClientAccessDestroy = async (id: string, options?: RequestInit): Promise<immigrationDossiersClientAccessDestroyResponse> => {
  
  return apiFetch<immigrationDossiersClientAccessDestroyResponse>(getImmigrationDossiersClientAccessDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getImmigrationDossiersClientAccessDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersClientAccessDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersClientAccessDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersClientAccessDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>>
    
    export type ImmigrationDossiersClientAccessDestroyMutationError = unknown

    export const useImmigrationDossiersClientAccessDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersClientAccessDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersClientAccessDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE-7: the estimated score next to the latest published rounds (indicative).
 */
export type immigrationDossiersDrawsRetrieveResponse200 = {
  data: ImmigrationDossiersDrawsRetrieve200
  status: 200
}
    
export type immigrationDossiersDrawsRetrieveResponseSuccess = (immigrationDossiersDrawsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersDrawsRetrieveResponse = (immigrationDossiersDrawsRetrieveResponseSuccess)

export const getImmigrationDossiersDrawsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/draws/`
}

export const immigrationDossiersDrawsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersDrawsRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersDrawsRetrieveResponse>(getImmigrationDossiersDrawsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersDrawsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/draws/`
    ] as const;
    }

    
export const getImmigrationDossiersDrawsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersDrawsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>> = ({ signal }) => immigrationDossiersDrawsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersDrawsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>>
export type ImmigrationDossiersDrawsRetrieveQueryError = unknown


export function useImmigrationDossiersDrawsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersDrawsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersDrawsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersDrawsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersDrawsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersDrawsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationDossiersEstimateRetrieveResponse200 = {
  data: ImmigrationDossiersEstimateRetrieve200
  status: 200
}
    
export type immigrationDossiersEstimateRetrieveResponseSuccess = (immigrationDossiersEstimateRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersEstimateRetrieveResponse = (immigrationDossiersEstimateRetrieveResponseSuccess)

export const getImmigrationDossiersEstimateRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/estimate/`
}

export const immigrationDossiersEstimateRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersEstimateRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersEstimateRetrieveResponse>(getImmigrationDossiersEstimateRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersEstimateRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/estimate/`
    ] as const;
    }

    
export const getImmigrationDossiersEstimateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersEstimateRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>> = ({ signal }) => immigrationDossiersEstimateRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersEstimateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>>
export type ImmigrationDossiersEstimateRetrieveQueryError = unknown


export function useImmigrationDossiersEstimateRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersEstimateRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersEstimateRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersEstimateRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersEstimateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersEstimateRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * EE-5: which IRCC forms this client needs and how to fill each answer.
 */
export type immigrationDossiersFormsRetrieveResponse200 = {
  data: ImmigrationDossiersFormsRetrieve200
  status: 200
}
    
export type immigrationDossiersFormsRetrieveResponseSuccess = (immigrationDossiersFormsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersFormsRetrieveResponse = (immigrationDossiersFormsRetrieveResponseSuccess)

export const getImmigrationDossiersFormsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/forms/`
}

export const immigrationDossiersFormsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersFormsRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersFormsRetrieveResponse>(getImmigrationDossiersFormsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersFormsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/forms/`
    ] as const;
    }

    
export const getImmigrationDossiersFormsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersFormsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>> = ({ signal }) => immigrationDossiersFormsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersFormsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>>
export type ImmigrationDossiersFormsRetrieveQueryError = unknown


export function useImmigrationDossiersFormsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersFormsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersFormsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersFormsRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersFormsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-079: Federal Skilled Worker eligibility, grid, funds, categories and deadlines.
 */
export type immigrationDossiersFswRetrieveResponse200 = {
  data: ImmigrationDossiersFswRetrieve200
  status: 200
}
    
export type immigrationDossiersFswRetrieveResponseSuccess = (immigrationDossiersFswRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersFswRetrieveResponse = (immigrationDossiersFswRetrieveResponseSuccess)

export const getImmigrationDossiersFswRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/fsw/`
}

export const immigrationDossiersFswRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersFswRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersFswRetrieveResponse>(getImmigrationDossiersFswRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersFswRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/fsw/`
    ] as const;
    }

    
export const getImmigrationDossiersFswRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersFswRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>> = ({ signal }) => immigrationDossiersFswRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersFswRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>>
export type ImmigrationDossiersFswRetrieveQueryError = unknown


export function useImmigrationDossiersFswRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersFswRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersFswRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersFswRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersFswRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersFswRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Et si ? » (P3-05): levers ranked by points gained, same table as the estimate.
 */
export type immigrationDossiersLeversRetrieveResponse200 = {
  data: ImmigrationDossiersLeversRetrieve200
  status: 200
}
    
export type immigrationDossiersLeversRetrieveResponseSuccess = (immigrationDossiersLeversRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersLeversRetrieveResponse = (immigrationDossiersLeversRetrieveResponseSuccess)

export const getImmigrationDossiersLeversRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/levers/`
}

export const immigrationDossiersLeversRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersLeversRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersLeversRetrieveResponse>(getImmigrationDossiersLeversRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersLeversRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/levers/`
    ] as const;
    }

    
export const getImmigrationDossiersLeversRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersLeversRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>> = ({ signal }) => immigrationDossiersLeversRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersLeversRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>>
export type ImmigrationDossiersLeversRetrieveQueryError = unknown


export function useImmigrationDossiersLeversRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersLeversRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersLeversRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersLeversRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersLeversRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersLeversRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-082: GET the live rules review and the latest saved one; POST saves a new review and,
with the client's consent, asks the AI to read the pieces and give an officer's view.
 */
export type immigrationDossiersOfficerReviewRetrieveResponse200 = {
  data: ImmigrationDossiersOfficerReviewRetrieve200
  status: 200
}

export type immigrationDossiersOfficerReviewRetrieveResponse202 = {
  data: OfficerReview
  status: 202
}
    
export type immigrationDossiersOfficerReviewRetrieveResponseSuccess = (immigrationDossiersOfficerReviewRetrieveResponse200 | immigrationDossiersOfficerReviewRetrieveResponse202) & {
  headers: Headers;
};
;

export type immigrationDossiersOfficerReviewRetrieveResponse = (immigrationDossiersOfficerReviewRetrieveResponseSuccess)

export const getImmigrationDossiersOfficerReviewRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/officer-review/`
}

export const immigrationDossiersOfficerReviewRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersOfficerReviewRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersOfficerReviewRetrieveResponse>(getImmigrationDossiersOfficerReviewRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersOfficerReviewRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/officer-review/`
    ] as const;
    }

    
export const getImmigrationDossiersOfficerReviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersOfficerReviewRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>> = ({ signal }) => immigrationDossiersOfficerReviewRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersOfficerReviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>>
export type ImmigrationDossiersOfficerReviewRetrieveQueryError = unknown


export function useImmigrationDossiersOfficerReviewRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersOfficerReviewRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersOfficerReviewRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersOfficerReviewRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersOfficerReviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-082: GET the live rules review and the latest saved one; POST saves a new review and,
with the client's consent, asks the AI to read the pieces and give an officer's view.
 */
export type immigrationDossiersOfficerReviewCreateResponse200 = {
  data: ImmigrationDossiersOfficerReviewCreate200
  status: 200
}

export type immigrationDossiersOfficerReviewCreateResponse202 = {
  data: OfficerReview
  status: 202
}
    
export type immigrationDossiersOfficerReviewCreateResponseSuccess = (immigrationDossiersOfficerReviewCreateResponse200 | immigrationDossiersOfficerReviewCreateResponse202) & {
  headers: Headers;
};
;

export type immigrationDossiersOfficerReviewCreateResponse = (immigrationDossiersOfficerReviewCreateResponseSuccess)

export const getImmigrationDossiersOfficerReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/officer-review/`
}

export const immigrationDossiersOfficerReviewCreate = async (id: string,
    strategyRequestRequest: StrategyRequestRequest, options?: RequestInit): Promise<immigrationDossiersOfficerReviewCreateResponse> => {
  
  return apiFetch<immigrationDossiersOfficerReviewCreateResponse>(getImmigrationDossiersOfficerReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      strategyRequestRequest,)
  }
);}




export const getImmigrationDossiersOfficerReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext> => {

const mutationKey = ['immigrationDossiersOfficerReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>, {id: string;data: StrategyRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersOfficerReviewCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersOfficerReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>>
    export type ImmigrationDossiersOfficerReviewCreateMutationBody = StrategyRequestRequest
    export type ImmigrationDossiersOfficerReviewCreateMutationError = unknown

    export const useImmigrationDossiersOfficerReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersOfficerReviewCreate>>,
        TError,
        {id: string;data: StrategyRequestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersOfficerReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The advisor read the latest review and dealt with its points (required to validate).
 */
export type immigrationDossiersOfficerReviewReadCreateResponse200 = {
  data: OfficerReview
  status: 200
}
    
export type immigrationDossiersOfficerReviewReadCreateResponseSuccess = (immigrationDossiersOfficerReviewReadCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersOfficerReviewReadCreateResponse = (immigrationDossiersOfficerReviewReadCreateResponseSuccess)

export const getImmigrationDossiersOfficerReviewReadCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/officer-review-read/`
}

export const immigrationDossiersOfficerReviewReadCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersOfficerReviewReadCreateResponse> => {
  
  return apiFetch<immigrationDossiersOfficerReviewReadCreateResponse>(getImmigrationDossiersOfficerReviewReadCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersOfficerReviewReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersOfficerReviewReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersOfficerReviewReadCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersOfficerReviewReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>>
    
    export type ImmigrationDossiersOfficerReviewReadCreateMutationError = unknown

    export const useImmigrationDossiersOfficerReviewReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersOfficerReviewReadCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersOfficerReviewReadCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE-7: provincial streams with each criterion ok / ko / unknown for this profile.
 */
export type immigrationDossiersProvincesRetrieveResponse200 = {
  data: ImmigrationDossiersProvincesRetrieve200
  status: 200
}
    
export type immigrationDossiersProvincesRetrieveResponseSuccess = (immigrationDossiersProvincesRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersProvincesRetrieveResponse = (immigrationDossiersProvincesRetrieveResponseSuccess)

export const getImmigrationDossiersProvincesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/provinces/`
}

export const immigrationDossiersProvincesRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersProvincesRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersProvincesRetrieveResponse>(getImmigrationDossiersProvincesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersProvincesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/provinces/`
    ] as const;
    }

    
export const getImmigrationDossiersProvincesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersProvincesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>> = ({ signal }) => immigrationDossiersProvincesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersProvincesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>>
export type ImmigrationDossiersProvincesRetrieveQueryError = unknown


export function useImmigrationDossiersProvincesRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersProvincesRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersProvincesRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersProvincesRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersProvincesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersProvincesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P3-07: numbered assessment report (PDF, agency header, indicative), printed in the
background; download it from Documents with its signed link.
 */
export type immigrationDossiersReportCreateResponse201 = {
  data: GeneratedDocument
  status: 201
}
    
export type immigrationDossiersReportCreateResponseSuccess = (immigrationDossiersReportCreateResponse201) & {
  headers: Headers;
};
;

export type immigrationDossiersReportCreateResponse = (immigrationDossiersReportCreateResponseSuccess)

export const getImmigrationDossiersReportCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/report/`
}

export const immigrationDossiersReportCreate = async (id: string,
    strategyRequestRequest: StrategyRequestRequest, options?: RequestInit): Promise<immigrationDossiersReportCreateResponse> => {
  
  return apiFetch<immigrationDossiersReportCreateResponse>(getImmigrationDossiersReportCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      strategyRequestRequest,)
  }
);}




export const getImmigrationDossiersReportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersReportCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersReportCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext> => {

const mutationKey = ['immigrationDossiersReportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersReportCreate>>, {id: string;data: StrategyRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersReportCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersReportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersReportCreate>>>
    export type ImmigrationDossiersReportCreateMutationBody = StrategyRequestRequest
    export type ImmigrationDossiersReportCreateMutationError = unknown

    export const useImmigrationDossiersReportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersReportCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersReportCreate>>,
        TError,
        {id: string;data: StrategyRequestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersReportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-080: GET the live analysis and the latest saved strategy; POST saves a new one and asks
the AI (in the background) to write the plan from the computed facts only.
 */
export type immigrationDossiersStrategyRetrieveResponse200 = {
  data: ImmigrationDossiersStrategyRetrieve200
  status: 200
}

export type immigrationDossiersStrategyRetrieveResponse202 = {
  data: Strategy
  status: 202
}
    
export type immigrationDossiersStrategyRetrieveResponseSuccess = (immigrationDossiersStrategyRetrieveResponse200 | immigrationDossiersStrategyRetrieveResponse202) & {
  headers: Headers;
};
;

export type immigrationDossiersStrategyRetrieveResponse = (immigrationDossiersStrategyRetrieveResponseSuccess)

export const getImmigrationDossiersStrategyRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/strategy/`
}

export const immigrationDossiersStrategyRetrieve = async (id: string, options?: RequestInit): Promise<immigrationDossiersStrategyRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersStrategyRetrieveResponse>(getImmigrationDossiersStrategyRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersStrategyRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/dossiers/${id}/strategy/`
    ] as const;
    }

    
export const getImmigrationDossiersStrategyRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersStrategyRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>> = ({ signal }) => immigrationDossiersStrategyRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersStrategyRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>>
export type ImmigrationDossiersStrategyRetrieveQueryError = unknown


export function useImmigrationDossiersStrategyRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersStrategyRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersStrategyRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersStrategyRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersStrategyRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-080: GET the live analysis and the latest saved strategy; POST saves a new one and asks
the AI (in the background) to write the plan from the computed facts only.
 */
export type immigrationDossiersStrategyCreateResponse200 = {
  data: ImmigrationDossiersStrategyCreate200
  status: 200
}

export type immigrationDossiersStrategyCreateResponse202 = {
  data: Strategy
  status: 202
}
    
export type immigrationDossiersStrategyCreateResponseSuccess = (immigrationDossiersStrategyCreateResponse200 | immigrationDossiersStrategyCreateResponse202) & {
  headers: Headers;
};
;

export type immigrationDossiersStrategyCreateResponse = (immigrationDossiersStrategyCreateResponseSuccess)

export const getImmigrationDossiersStrategyCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/strategy/`
}

export const immigrationDossiersStrategyCreate = async (id: string,
    strategyRequestRequest: StrategyRequestRequest, options?: RequestInit): Promise<immigrationDossiersStrategyCreateResponse> => {
  
  return apiFetch<immigrationDossiersStrategyCreateResponse>(getImmigrationDossiersStrategyCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      strategyRequestRequest,)
  }
);}




export const getImmigrationDossiersStrategyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext> => {

const mutationKey = ['immigrationDossiersStrategyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>, {id: string;data: StrategyRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersStrategyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersStrategyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>>
    export type ImmigrationDossiersStrategyCreateMutationBody = StrategyRequestRequest
    export type ImmigrationDossiersStrategyCreateMutationError = unknown

    export const useImmigrationDossiersStrategyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>, TError,{id: string;data: StrategyRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersStrategyCreate>>,
        TError,
        {id: string;data: StrategyRequestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersStrategyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The advisor has read and checked the latest strategy (required before any use).
 */
export type immigrationDossiersStrategyReviewCreateResponse200 = {
  data: Strategy
  status: 200
}
    
export type immigrationDossiersStrategyReviewCreateResponseSuccess = (immigrationDossiersStrategyReviewCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersStrategyReviewCreateResponse = (immigrationDossiersStrategyReviewCreateResponseSuccess)

export const getImmigrationDossiersStrategyReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/strategy-review/`
}

export const immigrationDossiersStrategyReviewCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersStrategyReviewCreateResponse> => {
  
  return apiFetch<immigrationDossiersStrategyReviewCreateResponse>(getImmigrationDossiersStrategyReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersStrategyReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersStrategyReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersStrategyReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersStrategyReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>>
    
    export type ImmigrationDossiersStrategyReviewCreateMutationError = unknown

    export const useImmigrationDossiersStrategyReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersStrategyReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersStrategyReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersSubmittedCreateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersSubmittedCreateResponseSuccess = (immigrationDossiersSubmittedCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersSubmittedCreateResponse = (immigrationDossiersSubmittedCreateResponseSuccess)

export const getImmigrationDossiersSubmittedCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/submitted/`
}

export const immigrationDossiersSubmittedCreate = async (id: string,
    submittedRequest: SubmittedRequest, options?: RequestInit): Promise<immigrationDossiersSubmittedCreateResponse> => {
  
  return apiFetch<immigrationDossiersSubmittedCreateResponse>(getImmigrationDossiersSubmittedCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submittedRequest,)
  }
);}




export const getImmigrationDossiersSubmittedCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>, TError,{id: string;data: SubmittedRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>, TError,{id: string;data: SubmittedRequest}, TContext> => {

const mutationKey = ['immigrationDossiersSubmittedCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>, {id: string;data: SubmittedRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationDossiersSubmittedCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersSubmittedCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>>
    export type ImmigrationDossiersSubmittedCreateMutationBody = SubmittedRequest
    export type ImmigrationDossiersSubmittedCreateMutationError = unknown

    export const useImmigrationDossiersSubmittedCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>, TError,{id: string;data: SubmittedRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersSubmittedCreate>>,
        TError,
        {id: string;data: SubmittedRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersSubmittedCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationDossiersValidateCreateResponse200 = {
  data: Dossier
  status: 200
}
    
export type immigrationDossiersValidateCreateResponseSuccess = (immigrationDossiersValidateCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersValidateCreateResponse = (immigrationDossiersValidateCreateResponseSuccess)

export const getImmigrationDossiersValidateCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/dossiers/${id}/validate/`
}

export const immigrationDossiersValidateCreate = async (id: string, options?: RequestInit): Promise<immigrationDossiersValidateCreateResponse> => {
  
  return apiFetch<immigrationDossiersValidateCreateResponse>(getImmigrationDossiersValidateCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationDossiersValidateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationDossiersValidateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationDossiersValidateCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersValidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>>
    
    export type ImmigrationDossiersValidateCreateMutationError = unknown

    export const useImmigrationDossiersValidateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersValidateCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersValidateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Profil express: a proposal the advisor reviews; nothing is saved here.
 */
export type immigrationDossiersExtractCreateResponse200 = {
  data: ImmigrationDossiersExtractCreate200
  status: 200
}
    
export type immigrationDossiersExtractCreateResponseSuccess = (immigrationDossiersExtractCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersExtractCreateResponse = (immigrationDossiersExtractCreateResponseSuccess)

export const getImmigrationDossiersExtractCreateUrl = () => {


  

  return `/api/v1/immigration/dossiers/extract/`
}

export const immigrationDossiersExtractCreate = async (extractRequest: ExtractRequest, options?: RequestInit): Promise<immigrationDossiersExtractCreateResponse> => {
  
  return apiFetch<immigrationDossiersExtractCreateResponse>(getImmigrationDossiersExtractCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extractRequest,)
  }
);}




export const getImmigrationDossiersExtractCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>, TError,{data: ExtractRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>, TError,{data: ExtractRequest}, TContext> => {

const mutationKey = ['immigrationDossiersExtractCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>, {data: ExtractRequest}> = (props) => {
          const {data} = props ?? {};

          return  immigrationDossiersExtractCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationDossiersExtractCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>>
    export type ImmigrationDossiersExtractCreateMutationBody = ExtractRequest
    export type ImmigrationDossiersExtractCreateMutationError = unknown

    export const useImmigrationDossiersExtractCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>, TError,{data: ExtractRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationDossiersExtractCreate>>,
        TError,
        {data: ExtractRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationDossiersExtractCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-115: files per status over every file the user may see (the list is paginated).
 */
export type immigrationDossiersSummaryRetrieveResponse200 = {
  data: DossierSummary
  status: 200
}
    
export type immigrationDossiersSummaryRetrieveResponseSuccess = (immigrationDossiersSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationDossiersSummaryRetrieveResponse = (immigrationDossiersSummaryRetrieveResponseSuccess)

export const getImmigrationDossiersSummaryRetrieveUrl = () => {


  

  return `/api/v1/immigration/dossiers/summary/`
}

export const immigrationDossiersSummaryRetrieve = async ( options?: RequestInit): Promise<immigrationDossiersSummaryRetrieveResponse> => {
  
  return apiFetch<immigrationDossiersSummaryRetrieveResponse>(getImmigrationDossiersSummaryRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDossiersSummaryRetrieveQueryKey = () => {
    return [
    `/api/v1/immigration/dossiers/summary/`
    ] as const;
    }

    
export const getImmigrationDossiersSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDossiersSummaryRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>> = ({ signal }) => immigrationDossiersSummaryRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDossiersSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>>
export type ImmigrationDossiersSummaryRetrieveQueryError = unknown


export function useImmigrationDossiersSummaryRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersSummaryRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDossiersSummaryRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDossiersSummaryRetrieve<TData = Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDossiersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDossiersSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Published Express Entry rounds (typed by the platform from canada.ca, read only).
 */
export type immigrationDrawsListResponse200 = {
  data: PaginatedDrawList
  status: 200
}
    
export type immigrationDrawsListResponseSuccess = (immigrationDrawsListResponse200) & {
  headers: Headers;
};
;

export type immigrationDrawsListResponse = (immigrationDrawsListResponseSuccess)

export const getImmigrationDrawsListUrl = (params?: ImmigrationDrawsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/draws/?${stringifiedParams}` : `/api/v1/immigration/draws/`
}

export const immigrationDrawsList = async (params?: ImmigrationDrawsListParams, options?: RequestInit): Promise<immigrationDrawsListResponse> => {
  
  return apiFetch<immigrationDrawsListResponse>(getImmigrationDrawsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationDrawsListQueryKey = (params?: ImmigrationDrawsListParams,) => {
    return [
    `/api/v1/immigration/draws/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationDrawsListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationDrawsList>>, TError = unknown>(params?: ImmigrationDrawsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationDrawsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationDrawsList>>> = ({ signal }) => immigrationDrawsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationDrawsListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationDrawsList>>>
export type ImmigrationDrawsListQueryError = unknown


export function useImmigrationDrawsList<TData = Awaited<ReturnType<typeof immigrationDrawsList>>, TError = unknown>(
 params: undefined |  ImmigrationDrawsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDrawsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDrawsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDrawsList<TData = Awaited<ReturnType<typeof immigrationDrawsList>>, TError = unknown>(
 params?: ImmigrationDrawsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationDrawsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationDrawsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationDrawsList<TData = Awaited<ReturnType<typeof immigrationDrawsList>>, TError = unknown>(
 params?: ImmigrationDrawsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationDrawsList<TData = Awaited<ReturnType<typeof immigrationDrawsList>>, TError = unknown>(
 params?: ImmigrationDrawsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationDrawsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationDrawsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsListResponse200 = {
  data: PaginatedProvincialInterestList
  status: 200
}
    
export type immigrationInterestsListResponseSuccess = (immigrationInterestsListResponse200) & {
  headers: Headers;
};
;

export type immigrationInterestsListResponse = (immigrationInterestsListResponseSuccess)

export const getImmigrationInterestsListUrl = (params?: ImmigrationInterestsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/interests/?${stringifiedParams}` : `/api/v1/immigration/interests/`
}

export const immigrationInterestsList = async (params?: ImmigrationInterestsListParams, options?: RequestInit): Promise<immigrationInterestsListResponse> => {
  
  return apiFetch<immigrationInterestsListResponse>(getImmigrationInterestsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationInterestsListQueryKey = (params?: ImmigrationInterestsListParams,) => {
    return [
    `/api/v1/immigration/interests/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationInterestsListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationInterestsList>>, TError = unknown>(params?: ImmigrationInterestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationInterestsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationInterestsList>>> = ({ signal }) => immigrationInterestsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationInterestsListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsList>>>
export type ImmigrationInterestsListQueryError = unknown


export function useImmigrationInterestsList<TData = Awaited<ReturnType<typeof immigrationInterestsList>>, TError = unknown>(
 params: undefined |  ImmigrationInterestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationInterestsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationInterestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationInterestsList<TData = Awaited<ReturnType<typeof immigrationInterestsList>>, TError = unknown>(
 params?: ImmigrationInterestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationInterestsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationInterestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationInterestsList<TData = Awaited<ReturnType<typeof immigrationInterestsList>>, TError = unknown>(
 params?: ImmigrationInterestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationInterestsList<TData = Awaited<ReturnType<typeof immigrationInterestsList>>, TError = unknown>(
 params?: ImmigrationInterestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationInterestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsCreateResponse201 = {
  data: ProvincialInterest
  status: 201
}
    
export type immigrationInterestsCreateResponseSuccess = (immigrationInterestsCreateResponse201) & {
  headers: Headers;
};
;

export type immigrationInterestsCreateResponse = (immigrationInterestsCreateResponseSuccess)

export const getImmigrationInterestsCreateUrl = () => {


  

  return `/api/v1/immigration/interests/`
}

export const immigrationInterestsCreate = async (provincialInterestRequest: ProvincialInterestRequest, options?: RequestInit): Promise<immigrationInterestsCreateResponse> => {
  
  return apiFetch<immigrationInterestsCreateResponse>(getImmigrationInterestsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provincialInterestRequest,)
  }
);}




export const getImmigrationInterestsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsCreate>>, TError,{data: ProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsCreate>>, TError,{data: ProvincialInterestRequest}, TContext> => {

const mutationKey = ['immigrationInterestsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationInterestsCreate>>, {data: ProvincialInterestRequest}> = (props) => {
          const {data} = props ?? {};

          return  immigrationInterestsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationInterestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsCreate>>>
    export type ImmigrationInterestsCreateMutationBody = ProvincialInterestRequest
    export type ImmigrationInterestsCreateMutationError = unknown

    export const useImmigrationInterestsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsCreate>>, TError,{data: ProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationInterestsCreate>>,
        TError,
        {data: ProvincialInterestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationInterestsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsRetrieveResponse200 = {
  data: ProvincialInterest
  status: 200
}
    
export type immigrationInterestsRetrieveResponseSuccess = (immigrationInterestsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationInterestsRetrieveResponse = (immigrationInterestsRetrieveResponseSuccess)

export const getImmigrationInterestsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/interests/${id}/`
}

export const immigrationInterestsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationInterestsRetrieveResponse> => {
  
  return apiFetch<immigrationInterestsRetrieveResponse>(getImmigrationInterestsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationInterestsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/interests/${id}/`
    ] as const;
    }

    
export const getImmigrationInterestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationInterestsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>> = ({ signal }) => immigrationInterestsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationInterestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>>
export type ImmigrationInterestsRetrieveQueryError = unknown


export function useImmigrationInterestsRetrieve<TData = Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationInterestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationInterestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationInterestsRetrieve<TData = Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationInterestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationInterestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationInterestsRetrieve<TData = Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationInterestsRetrieve<TData = Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationInterestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationInterestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsUpdateResponse200 = {
  data: ProvincialInterest
  status: 200
}
    
export type immigrationInterestsUpdateResponseSuccess = (immigrationInterestsUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationInterestsUpdateResponse = (immigrationInterestsUpdateResponseSuccess)

export const getImmigrationInterestsUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/interests/${id}/`
}

export const immigrationInterestsUpdate = async (id: string,
    provincialInterestRequest: ProvincialInterestRequest, options?: RequestInit): Promise<immigrationInterestsUpdateResponse> => {
  
  return apiFetch<immigrationInterestsUpdateResponse>(getImmigrationInterestsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provincialInterestRequest,)
  }
);}




export const getImmigrationInterestsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsUpdate>>, TError,{id: string;data: ProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsUpdate>>, TError,{id: string;data: ProvincialInterestRequest}, TContext> => {

const mutationKey = ['immigrationInterestsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationInterestsUpdate>>, {id: string;data: ProvincialInterestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationInterestsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationInterestsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsUpdate>>>
    export type ImmigrationInterestsUpdateMutationBody = ProvincialInterestRequest
    export type ImmigrationInterestsUpdateMutationError = unknown

    export const useImmigrationInterestsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsUpdate>>, TError,{id: string;data: ProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationInterestsUpdate>>,
        TError,
        {id: string;data: ProvincialInterestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationInterestsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsPartialUpdateResponse200 = {
  data: ProvincialInterest
  status: 200
}
    
export type immigrationInterestsPartialUpdateResponseSuccess = (immigrationInterestsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationInterestsPartialUpdateResponse = (immigrationInterestsPartialUpdateResponseSuccess)

export const getImmigrationInterestsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/interests/${id}/`
}

export const immigrationInterestsPartialUpdate = async (id: string,
    patchedProvincialInterestRequest: PatchedProvincialInterestRequest, options?: RequestInit): Promise<immigrationInterestsPartialUpdateResponse> => {
  
  return apiFetch<immigrationInterestsPartialUpdateResponse>(getImmigrationInterestsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedProvincialInterestRequest,)
  }
);}




export const getImmigrationInterestsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>, TError,{id: string;data: PatchedProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>, TError,{id: string;data: PatchedProvincialInterestRequest}, TContext> => {

const mutationKey = ['immigrationInterestsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>, {id: string;data: PatchedProvincialInterestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationInterestsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationInterestsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>>
    export type ImmigrationInterestsPartialUpdateMutationBody = PatchedProvincialInterestRequest
    export type ImmigrationInterestsPartialUpdateMutationError = unknown

    export const useImmigrationInterestsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>, TError,{id: string;data: PatchedProvincialInterestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationInterestsPartialUpdate>>,
        TError,
        {id: string;data: PatchedProvincialInterestRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationInterestsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE-7: a client's expressions of interest in provincial streams, tracked by the agency.
 */
export type immigrationInterestsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type immigrationInterestsDestroyResponseSuccess = (immigrationInterestsDestroyResponse204) & {
  headers: Headers;
};
;

export type immigrationInterestsDestroyResponse = (immigrationInterestsDestroyResponseSuccess)

export const getImmigrationInterestsDestroyUrl = (id: string,) => {


  

  return `/api/v1/immigration/interests/${id}/`
}

export const immigrationInterestsDestroy = async (id: string, options?: RequestInit): Promise<immigrationInterestsDestroyResponse> => {
  
  return apiFetch<immigrationInterestsDestroyResponse>(getImmigrationInterestsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getImmigrationInterestsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationInterestsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationInterestsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationInterestsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationInterestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationInterestsDestroy>>>
    
    export type ImmigrationInterestsDestroyMutationError = unknown

    export const useImmigrationInterestsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationInterestsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationInterestsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationInterestsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationItemsListResponse200 = {
  data: PaginatedDossierItemList
  status: 200
}
    
export type immigrationItemsListResponseSuccess = (immigrationItemsListResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsListResponse = (immigrationItemsListResponseSuccess)

export const getImmigrationItemsListUrl = (params?: ImmigrationItemsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/items/?${stringifiedParams}` : `/api/v1/immigration/items/`
}

export const immigrationItemsList = async (params?: ImmigrationItemsListParams, options?: RequestInit): Promise<immigrationItemsListResponse> => {
  
  return apiFetch<immigrationItemsListResponse>(getImmigrationItemsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationItemsListQueryKey = (params?: ImmigrationItemsListParams,) => {
    return [
    `/api/v1/immigration/items/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationItemsListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationItemsList>>, TError = unknown>(params?: ImmigrationItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationItemsList>>> = ({ signal }) => immigrationItemsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsList>>>
export type ImmigrationItemsListQueryError = unknown


export function useImmigrationItemsList<TData = Awaited<ReturnType<typeof immigrationItemsList>>, TError = unknown>(
 params: undefined |  ImmigrationItemsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationItemsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationItemsList<TData = Awaited<ReturnType<typeof immigrationItemsList>>, TError = unknown>(
 params?: ImmigrationItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationItemsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationItemsList<TData = Awaited<ReturnType<typeof immigrationItemsList>>, TError = unknown>(
 params?: ImmigrationItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationItemsList<TData = Awaited<ReturnType<typeof immigrationItemsList>>, TError = unknown>(
 params?: ImmigrationItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationItemsRetrieveResponse200 = {
  data: DossierItem
  status: 200
}
    
export type immigrationItemsRetrieveResponseSuccess = (immigrationItemsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsRetrieveResponse = (immigrationItemsRetrieveResponseSuccess)

export const getImmigrationItemsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/`
}

export const immigrationItemsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationItemsRetrieveResponse> => {
  
  return apiFetch<immigrationItemsRetrieveResponse>(getImmigrationItemsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationItemsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/items/${id}/`
    ] as const;
    }

    
export const getImmigrationItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationItemsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationItemsRetrieve>>> = ({ signal }) => immigrationItemsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsRetrieve>>>
export type ImmigrationItemsRetrieveQueryError = unknown


export function useImmigrationItemsRetrieve<TData = Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationItemsRetrieve<TData = Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationItemsRetrieve<TData = Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationItemsRetrieve<TData = Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationItemsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationItemsUpdateResponse200 = {
  data: DossierItem
  status: 200
}
    
export type immigrationItemsUpdateResponseSuccess = (immigrationItemsUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsUpdateResponse = (immigrationItemsUpdateResponseSuccess)

export const getImmigrationItemsUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/`
}

export const immigrationItemsUpdate = async (id: string,
    dossierItemRequest: DossierItemRequest, options?: RequestInit): Promise<immigrationItemsUpdateResponse> => {
  
  return apiFetch<immigrationItemsUpdateResponse>(getImmigrationItemsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dossierItemRequest,)
  }
);}




export const getImmigrationItemsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUpdate>>, TError,{id: string;data: DossierItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUpdate>>, TError,{id: string;data: DossierItemRequest}, TContext> => {

const mutationKey = ['immigrationItemsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationItemsUpdate>>, {id: string;data: DossierItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationItemsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationItemsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsUpdate>>>
    export type ImmigrationItemsUpdateMutationBody = DossierItemRequest
    export type ImmigrationItemsUpdateMutationError = unknown

    export const useImmigrationItemsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUpdate>>, TError,{id: string;data: DossierItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationItemsUpdate>>,
        TError,
        {id: string;data: DossierItemRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationItemsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationItemsPartialUpdateResponse200 = {
  data: DossierItem
  status: 200
}
    
export type immigrationItemsPartialUpdateResponseSuccess = (immigrationItemsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsPartialUpdateResponse = (immigrationItemsPartialUpdateResponseSuccess)

export const getImmigrationItemsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/`
}

export const immigrationItemsPartialUpdate = async (id: string,
    patchedDossierItemRequest: PatchedDossierItemRequest, options?: RequestInit): Promise<immigrationItemsPartialUpdateResponse> => {
  
  return apiFetch<immigrationItemsPartialUpdateResponse>(getImmigrationItemsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedDossierItemRequest,)
  }
);}




export const getImmigrationItemsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>, TError,{id: string;data: PatchedDossierItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>, TError,{id: string;data: PatchedDossierItemRequest}, TContext> => {

const mutationKey = ['immigrationItemsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>, {id: string;data: PatchedDossierItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationItemsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationItemsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>>
    export type ImmigrationItemsPartialUpdateMutationBody = PatchedDossierItemRequest
    export type ImmigrationItemsPartialUpdateMutationError = unknown

    export const useImmigrationItemsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>, TError,{id: string;data: PatchedDossierItemRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationItemsPartialUpdate>>,
        TError,
        {id: string;data: PatchedDossierItemRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationItemsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationItemsConfirmPassportCreateResponse200 = {
  data: DossierItem
  status: 200
}
    
export type immigrationItemsConfirmPassportCreateResponseSuccess = (immigrationItemsConfirmPassportCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsConfirmPassportCreateResponse = (immigrationItemsConfirmPassportCreateResponseSuccess)

export const getImmigrationItemsConfirmPassportCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/confirm-passport/`
}

export const immigrationItemsConfirmPassportCreate = async (id: string,
    passportValuesRequest: PassportValuesRequest, options?: RequestInit): Promise<immigrationItemsConfirmPassportCreateResponse> => {
  
  return apiFetch<immigrationItemsConfirmPassportCreateResponse>(getImmigrationItemsConfirmPassportCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      passportValuesRequest,)
  }
);}




export const getImmigrationItemsConfirmPassportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>, TError,{id: string;data: PassportValuesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>, TError,{id: string;data: PassportValuesRequest}, TContext> => {

const mutationKey = ['immigrationItemsConfirmPassportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>, {id: string;data: PassportValuesRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationItemsConfirmPassportCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationItemsConfirmPassportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>>
    export type ImmigrationItemsConfirmPassportCreateMutationBody = PassportValuesRequest
    export type ImmigrationItemsConfirmPassportCreateMutationError = unknown

    export const useImmigrationItemsConfirmPassportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>, TError,{id: string;data: PassportValuesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationItemsConfirmPassportCreate>>,
        TError,
        {id: string;data: PassportValuesRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationItemsConfirmPassportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * P4-03: the AI reads the passport in the background; the advisor then confirms.
 */
export type immigrationItemsReadPassportCreateResponse202 = {
  data: DossierItem
  status: 202
}
    
export type immigrationItemsReadPassportCreateResponseSuccess = (immigrationItemsReadPassportCreateResponse202) & {
  headers: Headers;
};
;

export type immigrationItemsReadPassportCreateResponse = (immigrationItemsReadPassportCreateResponseSuccess)

export const getImmigrationItemsReadPassportCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/read-passport/`
}

export const immigrationItemsReadPassportCreate = async (id: string, options?: RequestInit): Promise<immigrationItemsReadPassportCreateResponse> => {
  
  return apiFetch<immigrationItemsReadPassportCreateResponse>(getImmigrationItemsReadPassportCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImmigrationItemsReadPassportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['immigrationItemsReadPassportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  immigrationItemsReadPassportCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationItemsReadPassportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>>
    
    export type ImmigrationItemsReadPassportCreateMutationError = unknown

    export const useImmigrationItemsReadPassportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationItemsReadPassportCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getImmigrationItemsReadPassportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationItemsUploadCreateResponse200 = {
  data: DossierItem
  status: 200
}
    
export type immigrationItemsUploadCreateResponseSuccess = (immigrationItemsUploadCreateResponse200) & {
  headers: Headers;
};
;

export type immigrationItemsUploadCreateResponse = (immigrationItemsUploadCreateResponseSuccess)

export const getImmigrationItemsUploadCreateUrl = (id: string,) => {


  

  return `/api/v1/immigration/items/${id}/upload/`
}

export const immigrationItemsUploadCreate = async (id: string,
    uploadRequest: UploadRequest, options?: RequestInit): Promise<immigrationItemsUploadCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRequest.file)

  return apiFetch<immigrationItemsUploadCreateResponse>(getImmigrationItemsUploadCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getImmigrationItemsUploadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUploadCreate>>, TError,{id: string;data: UploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUploadCreate>>, TError,{id: string;data: UploadRequest}, TContext> => {

const mutationKey = ['immigrationItemsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationItemsUploadCreate>>, {id: string;data: UploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationItemsUploadCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationItemsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationItemsUploadCreate>>>
    export type ImmigrationItemsUploadCreateMutationBody = UploadRequest
    export type ImmigrationItemsUploadCreateMutationError = unknown

    export const useImmigrationItemsUploadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationItemsUploadCreate>>, TError,{id: string;data: UploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationItemsUploadCreate>>,
        TError,
        {id: string;data: UploadRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationItemsUploadCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * IRCC rule tables in force, with their source and verification status (read only).
 */
export type immigrationRulesListResponse200 = {
  data: PaginatedRuleTableList
  status: 200
}
    
export type immigrationRulesListResponseSuccess = (immigrationRulesListResponse200) & {
  headers: Headers;
};
;

export type immigrationRulesListResponse = (immigrationRulesListResponseSuccess)

export const getImmigrationRulesListUrl = (params?: ImmigrationRulesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/rules/?${stringifiedParams}` : `/api/v1/immigration/rules/`
}

export const immigrationRulesList = async (params?: ImmigrationRulesListParams, options?: RequestInit): Promise<immigrationRulesListResponse> => {
  
  return apiFetch<immigrationRulesListResponse>(getImmigrationRulesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationRulesListQueryKey = (params?: ImmigrationRulesListParams,) => {
    return [
    `/api/v1/immigration/rules/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationRulesListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationRulesList>>, TError = unknown>(params?: ImmigrationRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationRulesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationRulesList>>> = ({ signal }) => immigrationRulesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationRulesListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationRulesList>>>
export type ImmigrationRulesListQueryError = unknown


export function useImmigrationRulesList<TData = Awaited<ReturnType<typeof immigrationRulesList>>, TError = unknown>(
 params: undefined |  ImmigrationRulesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationRulesList>>,
          TError,
          Awaited<ReturnType<typeof immigrationRulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationRulesList<TData = Awaited<ReturnType<typeof immigrationRulesList>>, TError = unknown>(
 params?: ImmigrationRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationRulesList>>,
          TError,
          Awaited<ReturnType<typeof immigrationRulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationRulesList<TData = Awaited<ReturnType<typeof immigrationRulesList>>, TError = unknown>(
 params?: ImmigrationRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationRulesList<TData = Awaited<ReturnType<typeof immigrationRulesList>>, TError = unknown>(
 params?: ImmigrationRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationRulesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationSettingsListResponse200 = {
  data: PaginatedCanadaSettingsList
  status: 200
}
    
export type immigrationSettingsListResponseSuccess = (immigrationSettingsListResponse200) & {
  headers: Headers;
};
;

export type immigrationSettingsListResponse = (immigrationSettingsListResponseSuccess)

export const getImmigrationSettingsListUrl = (params?: ImmigrationSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/immigration/settings/?${stringifiedParams}` : `/api/v1/immigration/settings/`
}

export const immigrationSettingsList = async (params?: ImmigrationSettingsListParams, options?: RequestInit): Promise<immigrationSettingsListResponse> => {
  
  return apiFetch<immigrationSettingsListResponse>(getImmigrationSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationSettingsListQueryKey = (params?: ImmigrationSettingsListParams,) => {
    return [
    `/api/v1/immigration/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImmigrationSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof immigrationSettingsList>>, TError = unknown>(params?: ImmigrationSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationSettingsList>>> = ({ signal }) => immigrationSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationSettingsList>>>
export type ImmigrationSettingsListQueryError = unknown


export function useImmigrationSettingsList<TData = Awaited<ReturnType<typeof immigrationSettingsList>>, TError = unknown>(
 params: undefined |  ImmigrationSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationSettingsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationSettingsList<TData = Awaited<ReturnType<typeof immigrationSettingsList>>, TError = unknown>(
 params?: ImmigrationSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationSettingsList>>,
          TError,
          Awaited<ReturnType<typeof immigrationSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationSettingsList<TData = Awaited<ReturnType<typeof immigrationSettingsList>>, TError = unknown>(
 params?: ImmigrationSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationSettingsList<TData = Awaited<ReturnType<typeof immigrationSettingsList>>, TError = unknown>(
 params?: ImmigrationSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationSettingsRetrieveResponse200 = {
  data: CanadaSettings
  status: 200
}
    
export type immigrationSettingsRetrieveResponseSuccess = (immigrationSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type immigrationSettingsRetrieveResponse = (immigrationSettingsRetrieveResponseSuccess)

export const getImmigrationSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/immigration/settings/${id}/`
}

export const immigrationSettingsRetrieve = async (id: string, options?: RequestInit): Promise<immigrationSettingsRetrieveResponse> => {
  
  return apiFetch<immigrationSettingsRetrieveResponse>(getImmigrationSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImmigrationSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/immigration/settings/${id}/`
    ] as const;
    }

    
export const getImmigrationSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImmigrationSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>> = ({ signal }) => immigrationSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImmigrationSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>>
export type ImmigrationSettingsRetrieveQueryError = unknown


export function useImmigrationSettingsRetrieve<TData = Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationSettingsRetrieve<TData = Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof immigrationSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof immigrationSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImmigrationSettingsRetrieve<TData = Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useImmigrationSettingsRetrieve<TData = Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof immigrationSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImmigrationSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type immigrationSettingsUpdateResponse200 = {
  data: CanadaSettings
  status: 200
}
    
export type immigrationSettingsUpdateResponseSuccess = (immigrationSettingsUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationSettingsUpdateResponse = (immigrationSettingsUpdateResponseSuccess)

export const getImmigrationSettingsUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/settings/${id}/`
}

export const immigrationSettingsUpdate = async (id: string,
    canadaSettingsRequest: CanadaSettingsRequest, options?: RequestInit): Promise<immigrationSettingsUpdateResponse> => {
  
  return apiFetch<immigrationSettingsUpdateResponse>(getImmigrationSettingsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      canadaSettingsRequest,)
  }
);}




export const getImmigrationSettingsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsUpdate>>, TError,{id: string;data: CanadaSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsUpdate>>, TError,{id: string;data: CanadaSettingsRequest}, TContext> => {

const mutationKey = ['immigrationSettingsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationSettingsUpdate>>, {id: string;data: CanadaSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationSettingsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationSettingsUpdate>>>
    export type ImmigrationSettingsUpdateMutationBody = CanadaSettingsRequest
    export type ImmigrationSettingsUpdateMutationError = unknown

    export const useImmigrationSettingsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsUpdate>>, TError,{id: string;data: CanadaSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationSettingsUpdate>>,
        TError,
        {id: string;data: CanadaSettingsRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationSettingsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type immigrationSettingsPartialUpdateResponse200 = {
  data: CanadaSettings
  status: 200
}
    
export type immigrationSettingsPartialUpdateResponseSuccess = (immigrationSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type immigrationSettingsPartialUpdateResponse = (immigrationSettingsPartialUpdateResponseSuccess)

export const getImmigrationSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/immigration/settings/${id}/`
}

export const immigrationSettingsPartialUpdate = async (id: string,
    patchedCanadaSettingsRequest: PatchedCanadaSettingsRequest, options?: RequestInit): Promise<immigrationSettingsPartialUpdateResponse> => {
  
  return apiFetch<immigrationSettingsPartialUpdateResponse>(getImmigrationSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedCanadaSettingsRequest,)
  }
);}




export const getImmigrationSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>, TError,{id: string;data: PatchedCanadaSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>, TError,{id: string;data: PatchedCanadaSettingsRequest}, TContext> => {

const mutationKey = ['immigrationSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>, {id: string;data: PatchedCanadaSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  immigrationSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImmigrationSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>>
    export type ImmigrationSettingsPartialUpdateMutationBody = PatchedCanadaSettingsRequest
    export type ImmigrationSettingsPartialUpdateMutationError = unknown

    export const useImmigrationSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>, TError,{id: string;data: PatchedCanadaSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof immigrationSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedCanadaSettingsRequest},
        TContext
      > => {

      const mutationOptions = getImmigrationSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    